import { MealTypes, MenuOrderTypes,MealTypesReports,RadioTypesReports } from "../../../server/constants";
import {getAccessLevelByModule,getModuleEnum} from '../../../server/util';
const modEnum=getModuleEnum();

export const isShowOrderOption=(type,sid=0)=>{
    if(type==MealTypes.LUNCH){
        return (getAccessLevelByModule(modEnum.LOM,sid))?true:false;
    }
    if(type==MealTypes.BREAKFAST){
        return (getAccessLevelByModule(modEnum.BOM,sid))?true:false;
    }
    if(type==MealTypes.SNACK){
        return (getAccessLevelByModule(modEnum.SOM,sid))?true:false;
    }
    if(type==MealTypes.DINNER){
        return (getAccessLevelByModule(modEnum.DOM,sid))?true:false;
    }
  }
  export const isRegularLunchOrderType=(sid=0)=>{
    return getAccessLevelByModule(modEnum.MOT,sid)==MenuOrderTypes.REGULAR
}


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Transactions/orderOptionFilter.js